module.exports = __webpack_public_path__ + "static/microsoft_365_3-d59d7214dedc49647946382f6ce8485f.png";